import driverHttpAxios from '@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js'

// Override the default logic so we can handle 401 responses in our own Axios
// interceptor rather than automatically being logged out for every 401
driverHttpAxios.invalidToken = function (/* res */) {
  return false
}

export default driverHttpAxios
